
import { defineComponent, computed, onMounted } from "vue"
import { useStore } from "vuex"
import TheWarning from "@/components/TheWarning.vue"
import { serverURL } from "@/service/api/network"

export default defineComponent({
  components: { TheWarning },
  setup() {
    console.log("서버 네트워크: " + serverURL())

    const { state } = useStore()
    const isWarning = computed(() => state.warning.isWarning)
    history.pushState(null, "", location.href)
    window.onpopstate = function () {
      history.go(1)
    }
    onMounted(() => {
      document.getElementById("keypad_height")!.style.height = `${window.innerHeight - 50}px`
    })
    return {
      isWarning,
    }
  },
})
